export default __webpack_public_path__ + "static/media/bg3.c580efd3.jpg";